import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/events/streamEvents';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// One stream's events, newest occurrence first (the stream detail view).
// payload: { stream, limit?, before? } — ``before`` (epoch ms) pages back.
function* operation({ payload }) {
  try {
    const { stream, limit, before } = payload || {};
    const params = {};
    if (limit) params.limit = limit;
    if (before) params.before = before;
    const response = yield call(
      axios.get,
      `${config.API_URL}/event/streams/${encodeURIComponent(stream)}/events`,
      { headers: getLocalUser(), params }
    );
    // core wraps payloads under { data: ... }
    const body = response?.data?.data ?? response?.data ?? {};
    yield put(fetchSuccess(body));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
